import React from 'react';
import TextUtility from '../../../common/utility/TextUtility';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';
import PopupContainer from '../../../common/components/PopupContainer';
import CurrencyUtility from '../../../common/utility/CurrencyUtility';
import ErrorMessage from '../../../common/components/ErrorMessage';
import { FieldValidationErrorsType, SuperagentProgressParams } from '../../../common/form/FrekulForm';

type KaraokeUploadForm2ConfirmPopupFieldName = 'background_order'|'offvocal_order'|'lyrics';
type KaraokeUploadForm2ConfirmPopupFileName = 'song_vocal_off'|'song_vocal_on'|'movie';

// アップロード確認画面（ポップアップ）
export default function KaraokeUploadForm2ConfirmPopup({
  getValue,
  getFiles,
  getErrors,
  onSubmit,
  onCancel,
  submitting,
  progressInfo,
  modificationFeeAmount,
  remakeFeeAmount,
} : {
  getValue: (name: KaraokeUploadForm2ConfirmPopupFieldName) => string,
  getFiles: (name: KaraokeUploadForm2ConfirmPopupFileName) => FileList|null,
  getErrors: (name: KaraokeUploadForm2ConfirmPopupFieldName|KaraokeUploadForm2ConfirmPopupFileName) => FieldValidationErrorsType,
  onCancel: () => void,
  onSubmit: () => void,
  submitting: boolean,
  progressInfo: SuperagentProgressParams|null,
  modificationFeeAmount: number,
  remakeFeeAmount: number,
}) {
  const [agreement1, setAgreement1] = React.useState(false);
  const [agreement2, setAgreement2] = React.useState(false);

  const getFileName = (files: FileList|null) => files !== null ? files[0].name : 'なし';

  return (
    <PopupContainer title="カラオケデータのアップロード" onBeforeClose={() => !submitting} onClose={() => { if (!submitting) onCancel(); }}>
      <div className="loader_parts_container">
        <form className="cake_ajax_form">
          <div style={{
            color: 'red', marginBottom: '10px', padding: '10px', fontSize: '14px', background: '#fff4f4',
          }}
          >
            まだアップロードは完了していません。
            <br />
            大切なデータが旅立つ前にしっかりとチェックして、下の「データ納品」を押してください。いざ、冒険の始まりです！
          </div>
          <div className="karaoke_confirm" style={{ background: '#efefef', padding: '20px' }}>
            {getValue('background_order') === 'file' && (
            <dl style={{ marginBottom: '10px' }}>
              <dt style={{ fontWeight: 'bold' }}>背景用動画</dt>
              <dd>{getFileName(getFiles('movie'))}</dd>
            </dl>
            )}
            {getValue('background_order') !== 'file' && (
            <dl style={{ marginBottom: '10px' }}>
              <dt style={{ fontWeight: 'bold' }}>歌あり音源</dt>
              <dd>{getFileName(getFiles('song_vocal_on'))}</dd>
            </dl>
            )}
            {getValue('offvocal_order') !== 'vocal_removal' && (
            <dl style={{ marginBottom: '10px' }}>
              <dt style={{ fontWeight: 'bold' }}>歌なし音源</dt>
              <dd>{getFileName(getFiles('song_vocal_off'))}</dd>
            </dl>
            )}
            <dl style={{ marginBottom: '10px' }}>
              <dt style={{ fontWeight: 'bold' }}>歌詞</dt>
              <dd>{TextUtility.nl2br(getValue('lyrics'))}</dd>
            </dl>
          </div>
          <p>上記のデータで作業に入ります。</p>
          <p style={{ color: 'red' }}>{`アップロード後の訂正は、手数料（${CurrencyUtility.format(modificationFeeAmount)}～${CurrencyUtility.format(remakeFeeAmount)}円）が発生しますのでご了承ください。`}</p>
          <div className="pop_chekbox" style={{ width: '100%' }}>
            <span style={!submitting ? {} : { pointerEvents: 'none' }}>
              <CustomCheckbox
                checked={agreement1}
                setChecked={(checked) => setAgreement1(checked)}
                disabled={submitting}
              >
                データに間違いありません。
              </CustomCheckbox>
            </span>
            <span style={!submitting ? {} : { pointerEvents: 'none' }}>
              <CustomCheckbox
                checked={agreement2}
                setChecked={(checked) => setAgreement2(checked)}
                disabled={submitting}
              >
                歌詞はこのままカラオケのテロップになることを了承します。
              </CustomCheckbox>
            </span>
            {submitting && progressInfo !== null && (
            <p style={{ color: 'red' }}>
              通信中です。画面を閉じないでください。
              {progressInfo.percent}
              {' '}
              (残り:
              {progressInfo.remaining}
              )
            </p>
            )}
            <ErrorMessage type="error" validationErrors={getErrors('movie')} />
            <ErrorMessage type="error" validationErrors={getErrors('song_vocal_on')} />
            <ErrorMessage type="error" validationErrors={getErrors('song_vocal_off')} />
            <ErrorMessage type="error" validationErrors={getErrors('lyrics')} />
          </div>
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => { if (!submitting) onCancel(); }}>戻る</CustomButton>
              <CustomButton type="default-split" disabled={!(agreement1 && agreement2 && !submitting)} onClick={() => onSubmit()}>データ納品</CustomButton>
            </li>
          </ul>
        </form>
      </div>
    </PopupContainer>
  );
}
